"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var instance_1 = require("./instance");
var Main = /** @class */ (function () {
    function Main() {
        //
    }
    Main.load = function () {
        // Set up static and singleton instances
        // Initiate the real deal
        var app = new instance_1.default();
    };
    return Main;
}());
exports.default = Main;
Main.load();
